/* ============================================================
   SmokeZero · maquette V3 : interactions
   ============================================================ */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gsapOK = !!(window.gsap && window.ScrollTrigger) && !reduced;

  if (!gsapOK) document.documentElement.classList.add('no-gsap');
  else gsap.registerPlugin(ScrollTrigger);

  /* Stockage résilient : cookies bloqués, sandbox, quota */
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } }
  };

  /* ---------- Rendus produit ---------- */
  if (window.SBProduct) SBProduct.renderAll();

  /* ---------- Catalogue (maquette) ---------- */
  const CATALOG = {
    original: { name: 'smokebuddy original', price: 24.9, size: 'original' },
    jr:       { name: 'smokebuddy jr',       price: 19.9, size: 'jr' },
    duo:      { name: 'pack duo',            price: 39.9, size: 'original' }
  };
  const CW_NAMES = { noir: 'Noir', craie: 'Craie', sauge: 'Sauge', ardoise: 'Ardoise', rose: 'Rose' };
  /* seuil de livraison offerte (euros), à garder aligné sur livraison.seuilCentimes de config/projet.json */
  const FREE_SHIP = 25;

  const eur = n => n.toFixed(2).replace('.', ',') + ' €';

  /* délai annoncé : 8 à 15 jours ouvrés (week-ends exclus) */
  const SHIP_DAYS = [5, 10];
  const bizDate = n => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  /* délai propre au produit (data-min, data-max posés par la fiche), sinon celui de la boutique */
  const deliveryRange = (el) => {
    const fmt = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long' });
    const min = +(el && el.dataset.min) || SHIP_DAYS[0], max = +(el && el.dataset.max) || SHIP_DAYS[1];
    return T('delivery_range', 'du {from} au {to}', { from: fmt.format(bizDate(min)), to: fmt.format(bizDate(max)) });
  };

  /* ---------- Textes ----------
     Français dans ce fichier ; sur la boutique, le thème fournit la langue du
     visiteur (window.SZ_T, clés scripts.* des fichiers de langue, recopiées par
     scripts/build-theme.mjs depuis les appels T() ci-dessous). */
  const T = (k, fr, vars = {}) => Object.entries(vars).reduce(
    (s, [a, b]) => s.split(`{${a}}`).join(b), (window.SZ_T && window.SZ_T[k]) || fr);
  /* anglais britannique (28 October), comme les textes du site */
  const LOCALE = (document.documentElement.lang || 'fr') === 'en' ? 'en-GB' : (document.documentElement.lang || 'fr');

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.innerHTML = '<span class="tick">✓</span><span class="toast-msg"></span>';
      document.body.appendChild(el);
    }
    $('.toast-msg', el).textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }

  /* ---------- Age gate ---------- */
  const gate = $('.age-gate');
  if (gate) {
    if (store.get('sb_age18') === '1') gate.classList.add('is-hidden');
    document.body.classList.toggle('gate-open', !gate.classList.contains('is-hidden'));
    $('.age-yes', gate)?.addEventListener('click', () => {
      gate.classList.add('is-hidden');
      document.body.classList.remove('gate-open');
      store.set('sb_age18', '1');
    });
  }

  /* ---------- Cookies ---------- */
  const cookieBar = $('.cookie-bar');
  if (cookieBar && !store.get('sb_cookies')) {
    setTimeout(() => cookieBar.classList.add('is-visible'), 1800);
  }
  $$('.cookie-bar button').forEach(b =>
    b.addEventListener('click', () => {
      store.set('sb_cookies', b.classList.contains('cookie-accept') ? 'all' : 'essential');
      cookieBar.classList.remove('is-visible');
    })
  );

  /* ---------- Accordéons ---------- */
  $$('.accordion').forEach(acc => {
    $$('.acc-item', acc).forEach(item => {
      $('.acc-trigger', item).addEventListener('click', () => {
        const open = item.classList.contains('is-open');
        $$('.acc-item.is-open', acc).forEach(i => i.classList.remove('is-open'));
        if (!open) item.classList.add('is-open');
      });
    });
  });

  /* ---------- Panier ----------
     Maquette : panier local (localStorage). Boutique Shopify (window.SZ_SHOP,
     déclaré par le thème) : vrai panier via l'API AJAX Shopify, paiement
     Shopify. Les deux partagent le tiroir, son rendu et ses boutons. */
  const SHOP = window.SZ_SHOP || null;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const shopCart = SHOP && (() => {
    const root = SHOP.root.endsWith('/') ? SHOP.root : SHOP.root + '/';
    const cents = n => eur(n / 100);
    let state = { items: [], item_count: 0, total_price: 0 };
    const req = (path, body) => fetch(root + path, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } }
    ).then(r => r.json().then(d => (r.ok ? d : Promise.reject(d))));
    const set = c => { state = c; render(); return c; };
    const refresh = () => req('cart.js').then(set);
    const add = (id, quantity) => req('cart/add.js', { items: [{ id: +id, quantity }] }).then(refresh);
    const change = (key, quantity) => req('cart/change.js', { id: key, quantity }).then(set);
    const thumb = url => url ? url + (url.includes('?') ? '&' : '?') + 'width=240' : '';
    function render() {
      const list = $('.drawer-items');
      $$('.cart-count').forEach(el => { el.textContent = state.item_count; });
      if (!list) return;
      list.innerHTML = state.items.length
        ? state.items.map(it => `
          <div class="cart-line">
            <div class="thumb">${it.image ? `<img class="pv" src="${esc(thumb(it.image))}" alt="">` : ''}</div>
            <div>
              <h4>${esc(it.product_title.replace('®', ''))}</h4>
              ${it.variant_title ? `<p class="variant">${T('cart_variant', 'Coloris : {v}', { v: esc(it.variant_title) })}</p>` : '<p class="variant">&nbsp;</p>'}
              <span class="qty">
                <button data-key="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="${T('qty_less', 'Réduire')}">−</button>
                <span>${it.quantity}</span>
                <button data-key="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="${T('qty_more', 'Augmenter')}">+</button>
              </span>
            </div>
            <b class="line-price">${cents(it.final_line_price)}</b>
          </div>`).join('')
        : `<p class="drawer-empty">${T('cart_empty', 'Votre panier est vide, pour l’instant.')}</p>`;
      $$('.qty button[data-key]', list).forEach(b =>
        b.addEventListener('click', () => { b.disabled = true; change(b.dataset.key, +b.dataset.q).catch(() => toast(T('cart_error', 'Mise à jour impossible, réessayez.'))); })
      );
      shipProgress(state.total_price / 100);
    }
    return { refresh, add, render };
  })();

  function shipProgress(total) {
    const totalEl = $('.drawer-total b');
    if (totalEl) totalEl.textContent = eur(total);
    const bar = $('.ship-bar i');
    const txt = $('.shipping-progress p');
    if (bar && txt) {
      bar.style.width = Math.min(100, (total / FREE_SHIP) * 100) + '%';
      txt.innerHTML = total >= FREE_SHIP
        ? T('ship_free', '<b>Livraison suivie offerte.</b> Merci pour votre courtoisie.')
        : T('ship_left', 'Plus que <b>{amount}</b> pour la livraison suivie offerte.', { amount: eur(FREE_SHIP - total) });
    }
  }

  const readCart = () => {
    try {
      const raw = JSON.parse(store.get('sb_cart') || '[]');
      return Array.isArray(raw)
        ? raw.filter(l => l && CATALOG[l.id] && typeof l.qty === 'number' && l.qty > 0 && typeof l.price === 'number')
        : [];
    } catch (e) { return []; }
  };
  let cart = readCart();

  /* resynchronisation : retour bfcache et second onglet */
  window.addEventListener('pageshow', e => { if (e.persisted) { cart = readCart(); renderCart(); } });
  window.addEventListener('storage', e => { if (e.key === 'sb_cart') { cart = readCart(); renderCart(); } });

  const saveCart = () => store.set('sb_cart', JSON.stringify(cart));
  const cartTotal = () => cart.reduce((s, l) => s + l.price * l.qty, 0);
  const cartCount = () => cart.reduce((s, l) => s + l.qty, 0);

  function renderCart() {
    if (shopCart) { shopCart.render(); return; }
    const list = $('.drawer-items');
    if (!list) return;
    $$('.cart-count').forEach(el => { el.textContent = cartCount(); });

    if (!cart.length) {
      list.innerHTML = `<p class="drawer-empty">${T('cart_empty', 'Votre panier est vide, pour l’instant.')}</p>`;
    } else {
      list.innerHTML = cart.map((l, i) => `
        <div class="cart-line">
          <div class="thumb">${window.SBProduct ? SBProduct.buildVisual({ size: l.size, cw: l.cw || 'noir' }) : ''}</div>
          <div>
            <h4>${l.name}</h4>
            <p class="variant">${T('cart_variant', 'Coloris : {v}', { v: CW_NAMES[l.cw] || 'Noir' })}</p>
            <span class="qty">
              <button data-i="${i}" data-d="-1" aria-label="${T('qty_less', 'Réduire')}">−</button>
              <span>${l.qty}</span>
              <button data-i="${i}" data-d="1" aria-label="${T('qty_more', 'Augmenter')}">+</button>
            </span>
          </div>
          <b class="line-price">${eur(l.price * l.qty)}</b>
        </div>`).join('');
      $$('.qty button', list).forEach(b =>
        b.addEventListener('click', () => {
          const l = cart[+b.dataset.i];
          l.qty += +b.dataset.d;
          if (l.qty <= 0) cart.splice(+b.dataset.i, 1);
          saveCart(); renderCart();
        })
      );
    }

    shipProgress(cartTotal());
  }

  function openCart() {
    document.body.classList.add('cart-open');
    if (shopCart) shopCart.refresh().catch(() => {}); else renderCart();
  }
  function closeCart() { document.body.classList.remove('cart-open'); }

  $$('.cart-btn').forEach(b => b.addEventListener('click', openCart));
  $('.drawer-close')?.addEventListener('click', closeCart);
  $('.drawer-backdrop')?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCart(); document.body.classList.remove('menu-open'); }
  });

  /* sélecteur de langue : se referme au clic à l'extérieur ou sur Échap */
  const closeLang = e => $$('.lang-menu[open]').forEach(d => { if (!e || !d.contains(e.target)) d.removeAttribute('open'); });
  document.addEventListener('click', closeLang);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLang(); });

  /* ---------- Menu mobile ---------- */
  $('.burger')?.addEventListener('click', () => document.body.classList.toggle('menu-open'));
  $$('.mm-link').forEach(a => a.addEventListener('click', () => document.body.classList.remove('menu-open')));

  function addToCart(pid, cw = 'noir', qty = 1) {
    const p = CATALOG[pid];
    if (!p) return;
    const found = cart.find(l => l.id === pid && l.cw === cw);
    if (found) found.qty += qty;
    else cart.push({ id: pid, name: p.name, price: p.price, size: p.size, cw, qty });
    saveCart(); renderCart();
    toast(T('added', '{name} ajouté au panier', { name: p.name }));
    setTimeout(openCart, 350);
  }

  $$('[data-add]').forEach(b =>
    b.addEventListener('click', e => {
      const qty = +($('.buy-qty span')?.textContent || 1);
      if (shopCart) {
        /* boutique : coloris choisi porté par le bouton (data-variant-id) */
        e.preventDefault();
        if (b.disabled) return;
        b.disabled = true;
        shopCart.add(b.dataset.variantId, b.dataset.usePdpState ? qty : 1)
          .then(() => { toast(T('added', '{name} ajouté au panier', { name: b.dataset.title || T('item', 'Article') })); setTimeout(openCart, 350); })
          .catch(err => toast(err?.description || T('add_error', 'Ajout impossible pour le moment.')))
          .finally(() => { b.disabled = false; });
        return;
      }
      const cw = b.dataset.usePdpState ? (pdpState?.cw || 'noir') : (b.dataset.cw || 'noir');
      const pid = b.dataset.usePdpState ? (pdpState?.size === 'jr' ? 'jr' : 'original') : b.dataset.add;
      addToCart(pid, cw, b.dataset.usePdpState ? qty : 1);
    })
  );

  $('.checkout-btn')?.addEventListener('click', () => {
    if (SHOP) { location.href = (SHOP.root.endsWith('/') ? SHOP.root : SHOP.root + '/') + 'checkout'; return; }
    toast('Paiement désactivé pendant la phase d\'aperçu.');
  });

  /* ---------- Newsletter / lang ---------- */
  /* maquette seulement : sur la boutique, le formulaire est envoyé à Shopify */
  if (!SHOP) $$('form.newsletter').forEach(f =>
    f.addEventListener('submit', e => {
      e.preventDefault();
      f.querySelector('input').value = '';
      toast(T('newsletter_ok', 'Merci. Vous êtes sur la liste.'));
    })
  );
  /* maquette seulement : sur la boutique, le sélecteur de langue est un vrai formulaire */
  if (!SHOP) $('.lang-toggle')?.addEventListener('click', () =>
    toast('La version anglaise arrive à l\'ouverture de la boutique.')
  );

  /* ---------- Page produit ---------- */
  const pdpVisual = $('#pdp-visual');
  const pdpState = { cw: 'noir', view: 'front', size: 'original' };

  if (pdpVisual) {
    const params = new URLSearchParams(location.search);
    if (params.get('size') === 'jr') pdpState.size = 'jr';

    const VIEW_LABELS = {
      photo: { front: 'photo produit · face', studio: 'photo studio', duo: 'photo produit · échelle', cut: 'photo produit · coupe technique' },
      svg: { front: 'rendu vectoriel · photo du coloris à venir', cut: 'illustration technique · coupe' }
    };

    function renderPDP() {
      if (!window.SBProduct) return;
      pdpVisual.dataset.view = pdpState.view;
      pdpVisual.dataset.size = pdpState.size;
      pdpVisual.dataset.colorway = pdpState.cw;
      const mode = SBProduct.render(pdpVisual);
      $('.pdp-main').dataset.watermark = (VIEW_LABELS[mode] || {})[pdpState.view] || '';
    }

    function applySize() {
      const isJr = pdpState.size === 'jr';
      $('.pdp-title').innerHTML = isJr ? 'smokebuddy<sup>®</sup> jr' : 'smokebuddy<sup>®</sup> original';
      $('.pdp-price b').textContent = eur(isJr ? CATALOG.jr.price : CATALOG.original.price);
      $('#uses-line').textContent = isJr ? '~150 utilisations' : '~300 utilisations';
      const mb = $('.mobile-buybar .mb-price b') || $('.mobile-buybar .mb-price');
      if (mb) mb.textContent = eur(isJr ? CATALOG.jr.price : CATALOG.original.price);
      $$('.size-opt').forEach(o => o.classList.toggle('is-active', o.dataset.size === pdpState.size));
      renderPDP();
    }

    /* barre d'achat mobile : visible dès l'arrivée, masquée seulement quand le
       bouton principal est à l'écran (prix et achat toujours accessibles) */
    const buybar = $('.mobile-buybar');
    const mainBuy = $('.buy-row .btn');
    if (buybar && mainBuy) {
      let bbTick = false;
      const updateBuybar = () => {
        const r = mainBuy.getBoundingClientRect();
        buybar.classList.toggle('is-hidden', r.top < innerHeight && r.bottom > 0);
        bbTick = false;
      };
      window.addEventListener('scroll', () => {
        if (!bbTick) { bbTick = true; requestAnimationFrame(updateBuybar); }
      }, { passive: true });
      updateBuybar();
    }

    $$('.swatch').forEach(sw =>
      sw.addEventListener('click', () => {
        pdpState.cw = sw.dataset.cw;
        $$('.swatch').forEach(s => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        const out = $('#cw-name');
        if (out) out.textContent = CW_NAMES[pdpState.cw];
        renderPDP();
      })
    );

    $$('.pdp-thumb').forEach(th =>
      th.addEventListener('click', () => {
        pdpState.view = th.dataset.viewTarget;
        $$('.pdp-thumb').forEach(t => t.classList.remove('is-active'));
        th.classList.add('is-active');
        renderPDP();
      })
    );

    $$('.size-opt').forEach(o =>
      o.addEventListener('click', () => { pdpState.size = o.dataset.size; applySize(); })
    );

    $$('.buy-qty button').forEach(b =>
      b.addEventListener('click', () => {
        const span = $('.buy-qty span');
        span.textContent = Math.max(1, +span.textContent + +b.dataset.d);
      })
    );

    /* estimation de livraison dynamique */
    $$('#delivery-dates, .delivery-dates').forEach(el => { el.textContent = deliveryRange(el); });

    applySize();
  }

  /* ---------- Fiche produit Shopify ----------
     Pastilles = vraies déclinaisons : prix, disponibilité, photo du coloris,
     déclinaison envoyée au panier et adresse (?variant=) mises à jour. */
  const szPdp = $('#sz-pdp');
  const szData = $('#sz-pdp-data');
  if (szPdp && szData) {
    const { variants } = JSON.parse(szData.textContent);
    const photo = $('#pdp-photo');
    const buyBtns = $$('[data-add][data-use-pdp-state]');
    const idInput = $('#sz-variant-id');
    /* photos des coloris préchargées une fois la page posée : le changement
       de coloris est alors instantané, en fondu */
    const cache = {};
    window.addEventListener('load', () => setTimeout(() => variants.forEach(v => {
      if (v.image && !cache[v.image]) { cache[v.image] = new Image(); cache[v.image].src = v.image; }
    }), 600));
    let swapToken = 0;
    const showPhoto = (src, alt) => {
      if (!photo || !src || photo.dataset.src === src) return;
      const token = ++swapToken;
      photo.dataset.src = src;
      photo.classList.add('is-swapping');
      const img = cache[src] || (cache[src] = new Image());
      const apply = () => {
        if (token !== swapToken) return;
        photo.removeAttribute('srcset');
        photo.src = src;
        if (alt) photo.alt = alt;
        /* laisse le navigateur poser la nouvelle image avant le fondu d'entrée */
        setTimeout(() => { if (token === swapToken) photo.classList.remove('is-swapping'); }, 40);
      };
      if (img.complete && img.naturalWidth) setTimeout(apply, 140);
      else { img.onload = () => setTimeout(apply, 60); img.onerror = apply; if (!img.src) img.src = src; }
    };
    const select = v => {
      buyBtns.forEach(b => { b.dataset.variantId = v.id; b.disabled = !v.available; b.textContent = v.available ? T('add_to_cart', 'Ajouter au panier') : b.dataset.soon ? T('soon', 'Bientôt disponible') : T('sold_out', 'Épuisé'); });
      if (idInput) idInput.value = v.id;
      $$('.sz-price').forEach(el => { el.textContent = v.price.replace(' €', ' €'); });
      const out = $('#cw-name'); if (out) out.textContent = v.color;
      $$('.swatch').forEach(s => {
        const on = +s.dataset.variantId === v.id;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on);
      });
      showPhoto(v.image, v.alt);
      history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
    };
    $$('.swatch[data-variant-id]').forEach(s =>
      s.addEventListener('click', () => { const v = variants.find(x => x.id === +s.dataset.variantId); if (v) select(v); })
    );
  }

  /* commun aux deux fiches : quantité, barre d'achat mobile, estimation de livraison */
  if (szPdp) {
    $$('.buy-qty button').forEach(b =>
      b.addEventListener('click', () => {
        const span = $('.buy-qty span');
        span.textContent = Math.max(1, +span.textContent + +b.dataset.d);
      })
    );
    const buybar = $('.mobile-buybar');
    const mainBuy = $('.buy-row .btn');
    if (buybar && mainBuy) {
      let tick = false;
      const update = () => { const r = mainBuy.getBoundingClientRect(); buybar.classList.toggle('is-hidden', r.top < innerHeight && r.bottom > 0); tick = false; };
      window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
    $$('#delivery-dates, .delivery-dates').forEach(el => { el.textContent = deliveryRange(el); });
  }

  if (shopCart) shopCart.refresh().catch(() => {});
  else renderCart();

  /* ---------- Viewer de rotation produit ----------
     Séquence de vues pré-rendues dessinées sur un canvas, avec un fondu entre
     deux vues voisines : mouvement continu à la fréquence de l'écran, dans les
     deux sens, sans décodeur vidéo ni autoplay. Va-et-vient ambiant amorti aux
     extrémités ; le glisser (avec inertie) et le clavier prennent la main,
     l'ambiant reprend en douceur après une courte pause. */
  const spinStage = $('#spin-stage');
  if (spinStage) {
    const canvas = $('.spin-canvas', spinStage);
    const ctx = canvas.getContext('2d');
    const N = +spinStage.dataset.frames || 0;
    const LAST = N - 1;
    const PERIOD = 12000;       // durée d'un aller-retour ambiant (ms)
    const RESUME_AFTER = 1600;  // pause avant reprise de l'ambiant (ms)
    const DRAG_SPAN = 1.3;      // glisser sur toute la largeur = 1,3 balayage
    const frames = new Array(N).fill(null);
    let ready = false, inView = true, dragging = false, ambient = true;
    let pos = 0, target = 0, phase = 0, dir = 1, vel = 0;
    let startX = 0, startTarget = 0, lastMoveT = 0, idleSince = 0;
    let last = performance.now(), drawn = -1, ariaDeg = 0;

    const clamp = v => Math.max(0, Math.min(LAST, v));
    const url = i => spinStage.dataset.src.replace('{i}', String(i).padStart(3, '0'));
    /* vue la plus proche réellement chargée (tolère une image en échec) */
    const pick = i => {
      for (let d = 0; d < N; d++) {
        if (frames[i - d]) return frames[i - d];
        if (frames[i + d]) return frames[i + d];
      }
      return null;
    };

    /* vues détourées : fondu exact A×(1-f) + B×f par addition (« lighter »),
       couleur ET transparence, pour que la silhouette ne s'épaississe jamais */
    function draw() {
      if (!ready || Math.abs(pos - drawn) < 0.003) return;
      const i = Math.min(LAST, Math.floor(pos));
      const f = pos - i;
      const a = pick(i);
      if (!a) return;
      const b = i < LAST ? pick(i + 1) : null;
      const W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      if (b && b !== a && f > 0.004) {
        ctx.globalCompositeOperation = 'lighter';
        ctx.globalAlpha = 1 - f;
        ctx.drawImage(a, 0, 0, W, H);
        ctx.globalAlpha = f;
        ctx.drawImage(b, 0, 0, W, H);
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
      } else {
        ctx.drawImage(a, 0, 0, W, H);
      }
      drawn = pos;
    }

    function fit() {
      const r = spinStage.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round(r.width * dpr));
      canvas.height = Math.max(1, Math.round(r.height * dpr));
      ctx.imageSmoothingQuality = 'high';
      drawn = -1;
      draw();
    }

    /* chargement : une vue sur neuf d'abord (survol rapide), puis le reste.
       Le lecteur est prêt dès que tout est téléchargé ; le décodage est lancé
       en tâche de fond (un navigateur peut le différer, ex. onglet masqué).
       Les vues (1,8 Mo) partent après le chargement de la page : l'image fixe
       du produit, affichée d'ici là, n'est pas concurrencée. */
    const order = [];
    for (let i = 0; i < N; i += 9) order.push(i);
    for (let i = 0; i < N; i++) if (i % 9) order.push(i);
    let settled = 0;
    const settle = () => {
      if (++settled < N) return;
      ready = true;
      spinStage.classList.add('is-ready');
      fit();
    };
    const loadFrames = () => order.forEach(i => {
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        frames[i] = img;
        if (img.decode) img.decode().catch(() => {});
        settle();
      };
      img.onerror = settle;
      img.src = url(i);
    });
    const afterLoad = () => ('requestIdleCallback' in window
      ? requestIdleCallback(loadFrames, { timeout: 1500 })
      : setTimeout(loadFrames, 200));
    /* l'Original tourne en section 3 : vues chargées à l'approche de la section */
    if ('IntersectionObserver' in window) {
      const near = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        near.disconnect();
        afterLoad();
      }, { rootMargin: '900px 0px' });
      near.observe(spinStage);
    } else if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });

    /* reprend l'oscillation depuis la position courante, dans le dernier sens */
    function syncPhase() {
      const p = LAST ? pos / LAST : 0;
      const a = Math.acos(Math.max(-1, Math.min(1, 1 - 2 * p)));
      phase = dir >= 0 ? a : 2 * Math.PI - a;
    }

    function announce(p = target) {
      const deg = Math.round((p / LAST) * 180);
      if (deg === ariaDeg) return;
      ariaDeg = deg;
      spinStage.setAttribute('aria-valuenow', deg);
      spinStage.setAttribute('aria-valuetext',
        deg === 0 ? T('view_front', 'Vue de face') : deg === 180 ? T('view_back', 'Vue de dos') : T('view_deg', 'Vue tournée de {deg} degrés', { deg }));
    }

    function interact() {
      ambient = false;
      idleSince = performance.now();
      spinStage.classList.add('was-dragged');
    }

    function loop(now) {
      const dt = Math.min(64, now - last);
      last = now;
      if (ready && inView) {
        if (!dragging) {
          if (Math.abs(vel) > 0.0005) {
            /* élan après le lâcher, freiné progressivement */
            target = clamp(target + vel * dt);
            vel *= Math.exp(-dt / 260);
            if (target === 0 || target === LAST) vel = 0;
            idleSince = now;
          } else if (!reduced) {
            if (!ambient && now - idleSince > RESUME_AFTER) { vel = 0; syncPhase(); ambient = true; }
            if (ambient) {
              phase += (dt / PERIOD) * Math.PI * 2;
              target = ((1 - Math.cos(phase)) / 2) * LAST;
            }
          }
        }
        pos += (target - pos) * (1 - Math.exp(-dt / 70));
        draw();
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    spinStage.addEventListener('pointerdown', e => {
      if (!ready) return;
      dragging = true;
      vel = 0;
      interact();
      startX = e.clientX;
      startTarget = target = pos;
      lastMoveT = e.timeStamp;
      try { spinStage.setPointerCapture(e.pointerId); } catch (err) { /* pointeur synthétique */ }
    });
    spinStage.addEventListener('pointermove', e => {
      if (!dragging) return;
      const next = clamp(startTarget + ((e.clientX - startX) / spinStage.clientWidth) * LAST * DRAG_SPAN);
      const inst = (next - target) / Math.max(1, e.timeStamp - lastMoveT);
      vel = vel * 0.6 + inst * 0.4;
      if (next !== target) dir = next > target ? 1 : -1;
      target = next;
      lastMoveT = e.timeStamp;
      idleSince = performance.now();
    });
    const release = e => {
      if (!dragging) return;
      dragging = false;
      idleSince = performance.now();
      /* pas d'élan si le geste s'était arrêté avant le lâcher */
      if (reduced || (e && e.timeStamp - lastMoveT > 80)) vel = 0;
      vel = Math.max(-0.06, Math.min(0.06, vel));
      announce();
    };
    spinStage.addEventListener('pointerup', release);
    spinStage.addEventListener('pointercancel', release);

    /* curseur accessible : flèches (10° par appui), Début et Fin */
    spinStage.addEventListener('keydown', e => {
      if (!ready) return;
      const step = LAST / 18;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = target + step;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = target - step;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = LAST;
      if (next === null) return;
      e.preventDefault();
      interact();
      vel = 0;
      next = clamp(next);
      dir = next >= target ? 1 : -1;
      target = next;
      announce(next);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { inView = e.isIntersecting; }).observe(spinStage);
    }
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(spinStage);
    else window.addEventListener('resize', fit);
  }

  /* ---------- Trajet de l'air (« Comment ça marche ») ----------
     La fumée entre par l'embout, EN HAUT du produit ; l'air ressort par la
     grille, EN BAS. Les tracés et les étiquettes suivent la géométrie réelle
     du panneau (recalculée au redimensionnement) ; les particules empruntent
     les mêmes tracés via offset-path. */
  const howPanel = $('.how-panel');
  if (howPanel) {
    const svg = $('.how-paths', howPanel);
    const pIn = $('.hp-in', howPanel), pOut = $('.hp-out', howPanel);
    const lIn = $('.how-label--in', howPanel), lOut = $('.how-label--out', howPanel);
    const media = $('.how-media', howPanel);
    const partsIn = $$('.how-particles--in i', howPanel);
    const partsOut = $$('.how-particles--out i', howPanel);
    /* repères du dessin (fractions de la scène) : axe, haut de l'embout, bas de
       la grille, capuchons écartés ; l'air passe entre les pièces */
    const skG = $('.sk-scene', howPanel)?.dataset || {};
    const G = { cx: +skG.cx || 0.5, e: +skG.entree || 0.105, s: +skG.sortie || 0.885, ch: +skG.capHaut || 0.03, cb: +skG.capBas || 0.955 };

    const vertical = matchMedia('(max-width: 900px)');
    const setPaths = (dIn, dOut) => {
      pIn.setAttribute('d', dIn);
      pOut.setAttribute('d', dOut);
      partsIn.forEach(p => { p.style.offsetPath = `path("${dIn}")`; });
      partsOut.forEach(p => { p.style.offsetPath = `path("${dOut}")`; });
    };
    /* mobile : étiquettes dans les bandes au-dessus et au-dessous du média ;
       l'entrée descend dans l'embout, la sortie naît sous la grille */
    const layoutVertical = () => {
      const W = howPanel.clientWidth, H = howPanel.clientHeight;
      const side = media.clientWidth, top = media.offsetTop, left = media.offsetLeft;
      const band = Math.min(top, H - top - side);
      howPanel.classList.toggle('is-narrow', band < 30);
      if (band < 30) return;
      howPanel.style.setProperty('--m-top', `${top}px`);
      howPanel.style.setProperty('--m-side', `${side}px`);
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
      const cx = left + side * G.cx, yIn = top / 2, yOut = top + side + (H - top - side) / 2;
      const inStart = 18 + lIn.offsetWidth + 12, outEnd = W - 18 - lOut.offsetWidth - 12;
      /* l'entrée contourne le capuchon écarté et plonge dans l'embout ; la sortie
         s'écarte du capuchon inférieur avant de rejoindre l'étiquette */
      const yGapIn = top + side * (G.ch + G.e) / 2, yGapOut = top + side * (G.s + G.cb) / 2;
      setPaths(
        `M ${inStart} ${yIn} C ${cx - side * 0.3} ${yIn} ${cx - side * 0.3} ${yGapIn} ${cx} ${top + side * G.e}`,
        `M ${cx} ${top + side * G.s} C ${cx + side * 0.3} ${yGapOut} ${cx + side * 0.3} ${yOut} ${outEnd} ${yOut}`
      );
      Object.assign(lIn.style, { left: '18px', right: 'auto', top: `${yIn}px` });
      Object.assign(lOut.style, { left: 'auto', right: '18px', top: `${yOut}px` });
    };

    const layoutFlows = () => {
      if (vertical.matches) { layoutVertical(); return; }
      howPanel.style.removeProperty('--m-top');
      howPanel.style.removeProperty('--m-side');
      lIn.style.left = ''; lOut.style.right = '';
      const W = howPanel.clientWidth, H = howPanel.clientHeight, side = media.clientWidth;
      const x0 = (W - side) / 2, x1 = x0 + side, cx = x0 + side * G.cx;
      /* place pour une étiquette de chaque côté sans toucher le média */
      const narrow = x0 < Math.max(lIn.offsetWidth, lOut.offsetWidth) + 56;
      howPanel.classList.toggle('is-narrow', narrow);
      if (narrow) return;
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
      const yIn = H * (G.ch + G.e) / 2, yOut = H * (G.s + G.cb) / 2;
      /* entrée : part de l'étiquette, passe sous le capuchon écarté et plonge dans l'embout */
      const dIn = `M ${x0 - 14} ${yIn} C ${cx - side * 0.12} ${yIn} ${cx} ${yIn} ${cx} ${H * G.e}`;
      /* sortie : naît sous la grille, passe au-dessus du capuchon inférieur et file vers l'étiquette */
      const dOut = `M ${cx} ${H * G.s} C ${cx} ${yOut} ${cx + side * 0.06} ${yOut} ${x1 + 14} ${yOut}`;
      setPaths(dIn, dOut);
      lIn.style.right = `${W - x0 + 24}px`;
      lIn.style.top = `${yIn}px`;
      lOut.style.left = `${x1 + 24}px`;
      lOut.style.top = `${yOut}px`;
    };
    if ('ResizeObserver' in window) new ResizeObserver(layoutFlows).observe(howPanel);
    else window.addEventListener('resize', layoutFlows);
    vertical.addEventListener('change', layoutFlows);
    layoutFlows();
  }

  /* ---------- Film de marque (bloc ZÉRO) ----------
     Chargé seulement à l'approche de la section : 720p sur mobile, 1080p dès
     que le cadre dépasse ~1 300 pixels physiques (desktop large, Retina) et
     en plein écran. Lecture automatique muette quand la section est visible,
     pause hors écran ; en mouvement réduit, rien ne démarre sans un clic. */
  const film = $('.zero-film-video');
  if (film) {
    const frame = $('.zero-film-frame');
    const toggle = $('.zero-film-toggle');
    const full = $('.zero-film-full');
    let userPaused = reduced;

    const load = hd => {
      const src = hd ? film.dataset.srcHd : film.dataset.srcSd;
      if (film.getAttribute('src') === src) return;
      const t = film.currentTime, wasPlaying = !film.paused;
      film.src = src;
      film.preload = 'auto';
      if (t) film.addEventListener('loadedmetadata', () => { film.currentTime = t; }, { once: true });
      if (wasPlaying) film.play().catch(() => {});
    };
    const isFull = () => document.fullscreenElement === frame;
    const wantsHd = () => isFull() || frame.clientWidth * Math.min(window.devicePixelRatio || 1, 2) > 1300;
    const play = () => { load(wantsHd()); film.play().catch(() => {}); };
    const syncBtn = () => {
      const playing = !film.paused;
      toggle.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-label', playing ? T('film_pause', 'Mettre le film en pause') : T('film_play', 'Lire le film'));
    };

    film.addEventListener('play', syncBtn);
    film.addEventListener('pause', syncBtn);
    toggle.addEventListener('click', () => {
      if (film.paused) { userPaused = false; play(); }
      else { userPaused = true; film.pause(); }
    });
    full.addEventListener('click', () => {
      if (isFull()) { document.exitFullscreen().catch(() => {}); return; }
      if (frame.requestFullscreen) {
        frame.requestFullscreen().then(() => { userPaused = false; load(true); film.play().catch(() => {}); }).catch(() => {});
      } else if (film.webkitEnterFullscreen) {
        /* iPhone : plein écran natif de la vidéo, en 720p */
        play();
        film.webkitEnterFullscreen();
      }
    });
    document.addEventListener('fullscreenchange', () => {
      full.setAttribute('aria-label', isFull() ? T('film_exit', 'Quitter le plein écran') : T('film_full', 'Voir le film en plein écran'));
      if (!isFull()) load(wantsHd());
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { if (!userPaused) play(); }
        else if (!isFull()) film.pause();
      }, { threshold: 0.35 }).observe(frame);
    }
    syncBtn();
  }

  /* ---------- Fumée d'ouverture ----------
     Entièrement gérée par le petit script placé après la vidéo, dans le haut de
     page (démarrage dès la lecture de la page, sans attendre ce fichier). */

  /* ---------- Fiches techniques : onglets par format, plan qui se trace ----------
     Le plan (SVG) se dessine au premier passage et à chaque changement de
     format ; données et mode d'emploi apparaissent ensuite. Flèches gauche et
     droite pour passer d'un onglet à l'autre. */
  const fiches = $('.fiches');
  if (fiches) {
    const tabs = $$('[role="tab"]', fiches);
    const panels = $$('.fiche', fiches);
    const traitsDe = panel => $$('.sk-draw .sk-edge, .sk-draw .sk-thin', panel).filter(el => !el.closest('.sk-hidden'));
    const prepare = panel => {
      if (!gsapOK) return;
      traitsDe(panel).forEach(el => { const L = el.getTotalLength(); el.style.strokeDasharray = `${L} ${L}`; el.style.strokeDashoffset = L; });
      gsap.set($$('.sk-hidden, .sk-cordwrap, .sk-dim', panel), { opacity: 0 });
      gsap.set($$('.fiche-specs > div, .fiche-mode li, .fiche-note', panel), { opacity: 0, y: 10 });
    };
    const draw = panel => {
      if (!gsapOK) return;
      gsap.timeline()
        .to(traitsDe(panel), { strokeDashoffset: 0, duration: 1.2, ease: 'power2.inOut', stagger: 0.004 }, 0)
        .to($$('.sk-hidden, .sk-cordwrap, .sk-dim', panel), { opacity: 1, duration: 0.5, stagger: 0.08 }, 0.7)
        .to($$('.fiche-specs > div, .fiche-mode li, .fiche-note', panel), { opacity: 1, y: 0, duration: 0.5, stagger: 0.05, ease: 'power3.out' }, 0.2);
    };
    const show = (i, focus) => {
      tabs.forEach((tab, k) => {
        const on = k === i;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        tab.classList.toggle('is-active', on);
      });
      panels.forEach((panel, k) => { panel.hidden = k !== i; panel.classList.toggle('is-active', k === i); });
      if (focus) tabs[i].focus();
      prepare(panels[i]);
      draw(panels[i]);
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => { if (tab.getAttribute('aria-selected') !== 'true') show(i); });
      tab.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        show((i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length, true);
      });
    });
    if (gsapOK) {
      prepare(panels[0]);
      ScrollTrigger.create({ trigger: fiches, start: 'top 75%', once: true, onEnter: () => draw(panels.find(p => !p.hidden) || panels[0]) });
    }
  }

  /* ---------- GSAP ---------- */
  if (gsapOK) {
    /* Intro hero : le titre se matérialise comme une fumée qui se dissipe à l'envers */
    const hero = $('.hero');
    if (hero) {
      const title = $('#hero-title');
      if (title) {
        /* chaque ligne est découpée en mots, puis en lettres (toutes langues) */
        const esc = c => c.replace(/[&<>]/g, x => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[x]);
        $$('.ht', title).forEach(line => {
          line.innerHTML = line.textContent.split(/(\s+)/).map(p => /^\s*$/.test(p) ? p
            : `<span class="w">${[...p].map(c => `<span class="ch" style="display:inline-block">${esc(c)}</span>`).join('')}</span>`).join('');
        });
      }
      /* fumée d'ouverture en cours : l'entrée attend la dissipation (signal sz:reveal) */
      const root = document.documentElement;
      const waitSmoke = root.classList.contains('sz-intro') && !root.classList.contains('sz-intro-reveal');
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' }, paused: waitSmoke });
      if (waitSmoke) {
        const go = () => tl.play();
        document.addEventListener('sz:reveal', go, { once: true });
        setTimeout(go, 8000);
      }
      tl.from('.poster-top .eyebrow', { y: 24, opacity: 0, duration: 0.7 }, 0.1)
        .from('#hero-title .ch', {
          opacity: 0, y: 16, filter: 'blur(12px)', duration: 0.8, stagger: 0.022,
          onComplete() { gsap.set('#hero-title .ch', { clearProps: 'filter,transform,opacity' }); }
        }, 0.2)
        .from('.poster-bottom .hero-ctas', { y: 26, opacity: 0, duration: 0.7 }, 0.9)
        .from('.scroll-hint', { opacity: 0, duration: 0.8 }, 1.3);
      /* l'affiche se décale légèrement au défilement */
      gsap.to('.hero-photo img', {
        yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1 }
      });
    }

    /* Section 3 : l'Original entre en scène à l'arrivée de la section */
    const usesVisual = $('.uses-visual');
    if (usesVisual) {
      gsap.timeline({ defaults: { ease: 'power4.out' }, scrollTrigger: { trigger: usesVisual, start: 'top 80%' } })
        .from('.uses-visual .spin-stage', { scale: 0.94, opacity: 0, duration: 1.1 }, 0)
        .from('.uses-visual .hero-watermark', { opacity: 0, x: 60, duration: 1.4 }, 0.1)
        .from('.uses-visual .hero-tag', { opacity: 0, x: -14, duration: 0.6, stagger: 0.12, ease: 'power3.out' }, 0.6);
      gsap.to('.uses-visual .hero-scene', {
        yPercent: 18,
        scrollTrigger: { trigger: usesVisual, start: 'top bottom', end: 'bottom top', scrub: 1.2 }
      });
      gsap.to('.uses-visual .hero-watermark', {
        yPercent: -18,
        scrollTrigger: { trigger: usesVisual, start: 'top bottom', end: 'bottom top', scrub: 1 }
      });
    }

    /* (refonte du 19/10 : le bloc ZÉRO est retiré et le film vit dans la FAQ, sans effet de défilement) */

    /* CTA magnétiques (desktop uniquement) */
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('.hero-ctas .btn').forEach(b => {
        b.addEventListener('mousemove', e => {
          const r = b.getBoundingClientRect();
          gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.16, y: (e.clientY - r.top - r.height / 2) * 0.3, duration: 0.4 });
        });
        b.addEventListener('mouseleave', () => gsap.to(b, { x: 0, y: 0, duration: 0.5, ease: 'power3.out' }));
      });
    }

    /* Révélations génériques */
    gsap.utils.toArray('.reveal').forEach(el => {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 86%', once: true }
      });
    });

    /* Scrollytelling « comment ça marche » : la scène est collée en CSS
       (sticky), la progression du défilement dans la piste pilote l'étape.
       Sur un écran trop bas pour la scène, la section devient statique. */
    const how = $('.how');
    const track = $('.how-track');
    if (how && track) {
      const panel = $('.how-panel');
      const steps = $$('.how-step');
      const headerH = () => $('.site-header')?.offsetHeight || 72;
      const roomy = matchMedia('(min-width: 901px) and (min-height: 601px), (max-width: 900px) and (min-height: 521px)');
      let current = -1, st = null;

      /* Coupe A-A (dessin vectoriel). Au premier passage, les arêtes se
         tracent ; ensuite la progression de la piste pilote la frise :
         étape 1, les capuchons s'écartent le long de l'axe (vue éclatée) ;
         étape 2, la demi-coupe découvre le charbon actif et les particules
         retenues ; étape 3, l'air traverse le lit et sort par la grille.
         Écran trop bas (mode statique) : état final. */
      let sketch = () => {};
      const sk = $('.sk-scene');
      if (sk) {
        const media = sk.closest('.how-media');
        const q = s => $$(s, sk);
        const repere = n => [...q(`.sk-callout[data-n="${n}"]`), ...$$(`.how-callout[data-n="${n}"]`, media)];
        const traits = q('.sk-draw .sk-edge, .sk-draw .sk-thin').filter(el => !el.closest('.sk-hidden'));
        traits.forEach(el => { const L = el.getTotalLength(); el.style.strokeDasharray = `${L} ${L}`; el.style.strokeDashoffset = L; });
        const cotes = q('.sk-dimwrap');
        gsap.set(cotes, { opacity: 1 });
        gsap.set(q('.sk-dim, .sk-hidden, .sk-axis'), { opacity: 0 });
        const intro = gsap.timeline({ paused: true })
          .to(q('.sk-axis'), { opacity: 1, duration: 0.6 }, 0)
          .to(traits, { strokeDashoffset: 0, duration: 1.4, ease: 'power2.inOut', stagger: 0.006 }, 0.1)
          .to(q('.sk-hidden'), { opacity: 1, duration: 0.5 }, 1)
          .to(q('.sk-dim'), { opacity: 1, duration: 0.5 }, 1.1);
        ScrollTrigger.create({ trigger: media, start: 'top 85%', once: true, onEnter: () => intro.play() });
        const caps = q('.sk-cap');
        const volet = $('#sk-volet rect');
        const large = +volet.getAttribute('width');
        const tl = gsap.timeline({ paused: true, defaults: { ease: 'power2.inOut' } })
          .fromTo(caps, { y: 0 }, { y: i => +caps[i].dataset.dy, duration: 0.3 }, 0.2)
          .to(cotes, { opacity: 0, duration: 0.12 }, 0.18)
          .fromTo(q('.sk-path, .sk-cutmark'), { opacity: 0 }, { opacity: 1, duration: 0.15 }, 0.38)
          .fromTo([...repere(1), ...repere(2), ...repere(5)], { opacity: 0 }, { opacity: 1, duration: 0.12, stagger: 0.05 }, 0.5)
          .fromTo($('.how-sk-title', media), { opacity: 0 }, { opacity: 1, duration: 0.12 }, 0.6)
          .fromTo(volet, { attr: { width: 0 } }, { attr: { width: large }, duration: 0.4 }, 1.02)
          .fromTo(q('.sk-right-face'), { opacity: 1 }, { opacity: 0, duration: 0.25 }, 1.02)
          .fromTo(q('.sk-grains circle'), { opacity: 0 }, { opacity: 1, duration: 0.35, stagger: { each: 0.0015, from: 'random' } }, 1.2)
          .fromTo(repere(3), { opacity: 0 }, { opacity: 1, duration: 0.12 }, 1.3)
          .fromTo(q('.sk-traps'), { opacity: 0 }, { opacity: 1, duration: 0.25 }, 1.35)
          .fromTo(q('.sk-flows'), { opacity: 0 }, { opacity: 1, duration: 0.3 }, 2.02)
          .fromTo(repere(4), { opacity: 0 }, { opacity: 1, duration: 0.12 }, 2.12)
          .to({}, { duration: 0.4 }, 2.6);
        tl.progress(0);
        const prog = { v: 0 };
        const go = gsap.quickTo(prog, 'v', { duration: 0.45, ease: 'power2.out', onUpdate: () => tl.progress(prog.v) });
        sketch = (v, now) => {
          if (now) { prog.v = v; tl.progress(v); intro.progress(1); }
          else go(v);
        };
      }

      const setStep = i => {
        if (i === current) return;
        current = i;
        panel.dataset.step = i;
        steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      };

      const applyLayout = () => {
        if (roomy.matches) {
          how.classList.remove('is-static');
          if (!st) {
            st = ScrollTrigger.create({
              trigger: track,
              start: () => `top ${headerH()}px`,
              end: 'bottom bottom',
              invalidateOnRefresh: true,
              onUpdate(self) {
                const p = self.progress * 3;
                steps.forEach((s, k) => s.style.setProperty('--fill', Math.max(0, Math.min(1, p - k)).toFixed(3)));
                setStep(Math.min(2, Math.floor(p)));
                sketch(p / 3);
              }
            });
          }
        } else {
          if (st) { st.kill(); st = null; }
          how.classList.add('is-static');
          setStep(0);
          sketch(1, true);
        }
        ScrollTrigger.refresh();
      };
      roomy.addEventListener('change', applyLayout);
      setStep(0);
      applyLayout();
    }

    /* les positions de défilement se recalculent une fois les polices chargées */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ScrollTrigger.refresh());
  }
})();
